import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Blind_Sample_view_offcanvas from "../blind_Sample_view_offcanvas/Blind_Sample_view_offcanvas";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Blind_Sample_table() {
  const [view, setView] = useState(false);
  const data = [
    {
      testParameter: "IM",
      certifiedValue: "3.25",
      testMethod: "IS 1350 Part-I",
      observations: {
        obs1: "3.25",
        obs2: "3.30",
      },
      avg: "26.50",
      testedBy: "0.07",
      remark: "",
    },
    {
      testParameter: "VM",
      certifiedValue: "3.25",
      testMethod: "IS 1350 Part-I",
      observations: {
        obs1: "3.25",
        obs2: "",
      },
      avg: "",
      testedBy: "",
      remark: "",
    },
    {
      testParameter: "ASH",
      certifiedValue: "3.25",
      testMethod: "IS 1350 Part-II",
      observations: {
        obs1: "3.25",
        obs2: "",
      },
      avg: "",
      testedBy: "",
      remark: "",
    },
    {
      testParameter: "GCV",
      certifiedValue: "3.25",
      testMethod: "IS 1350 Part-II",
      observations: {
        obs1: "3.25",
        obs2: "",
      },
      avg: "",
      testedBy: "",
      remark: "",
    },
  ];
     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Test Parameter</th>
                  <th rowSpan="2">Certified Value</th>
                  <th rowSpan="2">Test Method</th>
                  <th colSpan="2">Observations</th>
                  <th rowSpan="2">Avg.</th>
                  <th rowSpan="2">Tested By</th>
                  <th rowSpan="2">Remark</th>
                  <th rowSpan="2">Action</th>
                </tr>
                <tr>
                  <th>OBS 01</th>
                  <th>OBS 02</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.testParameter}</td>
                    <td>{item.certifiedValue}</td>
                    <td>{item.testMethod}</td>
                    <td>{item.observations.obs1}</td>
                    <td>{item.observations.obs2}</td>
                    <td>{item.avg}</td>
                    <td>{item.testedBy}</td>
                    <td>{item.remark}</td>
                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => setView(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
         <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>
      {/* VIEW */}
      <Blind_Sample_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />
    </>
  );
}

export default Blind_Sample_table;
